export default "__VITE_ASSET__642602db__"